import constants from '../constants'
import store from '../state'
import router from '../router'

var firebase = window.firebase

/**
 * TODO: During the initial page load add an in between step that shows them
 * a loading component that handles the redirect to the login page or where
 * ever they intended to go.  That way the login page doesn't flash on every
 * full page load.
 */

/**
 * TODO: add a ?redirect= param to the login path and then redirect to that
 * page when authentication happens.
 */

/**
 * Watch for changes in Auth state and redirect to login if not authenticated
 */
function watchAuthState () {
  firebase.auth().onAuthStateChanged(function (user) {
    var requiresAuth = router.currentRoute.meta.auth
    if (user) {
      firebase
        .database()
        .ref('admins')
        .child(user.uid)
        .child('active')
        .once('value')
        .then(snap => {
          if (!snap.val()) {
            store.commit(constants.SIGN_OUT, 'User does not have required permissions')
            router.push({ path: '/login' })
          }
        })
    } else if (requiresAuth) {
      store.commit(constants.SIGN_OUT)
      router.push({ path: '/login' })
    }
  })
}

/**
 * Sign in with Google
 */
function signInWithGoogle () {
  var provider = new firebase.auth.GoogleAuthProvider()
  return firebase
    .auth()
    .signInWithPopup(provider)
    .then(function (result) {
      if (result.user) {
        store.commit(constants.SIGN_IN, {
          uid: result.user.uid
        })
        router.push('/')
        return result.user
      }
    })
    .catch(function (error) {
      return error.message
    })
}

/**
 * Sign out the current user
 */
function signOut () {
  return firebase
    .auth()
    .signOut()
    .catch(console.log)
}

/**
 * Check if the user is signed in
 */
function isSignedIn () {
  return store.state.signedIn
}

/**
 * Get the auth token for the current user
 * @returns {promise}
 */
function getAuthToken () {
  // request a new token if > 30 minutes old
  if (store.state.authIdToken &&
    new Date().getTime() - store.state.authIdTokenTimestamp < 30 * 30 * 1000
  ) {
    return Promise.resolve(store.state.authIdToken)
  } else {
    return firebase
      .auth()
      .currentUser
      .getIdToken(true)
      .then(function (token) {
        store.commit(constants.SAVE_ID_TOKEN, token)
        return token
      })
  }
}

export default {
  signInWithGoogle,
  signOut,
  isSignedIn,
  getAuthToken,
  watchAuthState
}



// WEBPACK FOOTER //
// ./src/auth/index.js